import Image from 'next/image';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const FogoIgnitionLockedTriggerDetails = ({ triggerType }: Props) => {
  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerValueDetail
        label="Network"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <Image src="/assets/webp/fogo.webp" width={12} height={12} alt="Fogo" />
            <span>Fogo</span>
          </div>
        }
      />
    </div>
  );
};
